"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatRgb = exports.enums = void 0;
const enums = {
  colorVariants: ["100", "200", "300", "400", "500", "600", "700", "800"],
  colors: ["blue", "green", "orange", "purple", "teal", "red", "yellow", "neutral", "destructive"],
  sizes: ["sm", "md", "lg"],
  dropdownSizes: ["small", "large"],
  buttonVariants: ["primary", "outline", "ghost"],
  fieldName: ["input", "textarea"],
  inputTypes: ["text", "search", "password", "color", "date", "email", "file", "number", "tel", "url", "hidden", "time"],
  boolean: [true, false],
  typographyVariants: ["heading0", "heading1", "heading2", "disp-heading", "section-title", "subtitle1", "subtitle2", "body-text1", "body-text2", "text1", "text2", "caption", "chart-text"],
  notificationVariants: ["success", "warning", "error"],
  tooltipPlacementPositions: ["top", "bottom", "right", "left"],
  popperPlacementPositions: ["auto", "top", "bottom", "right", "left"],
  switch: ["on", "off"],
  toggleSize: ["24px", "36px", "42px"],
  modalVariants: ["small", "medium"],
  badgesVariants: ["primary", "important", "added", "removal"],
  tagVariants: ["light", "dark"],
  lozengeVariants: ["default", "success", "failed", "pending"],
  tagDisplay: ["temporary", "permanent"],
  side: ["top", "bottom", "left", "right"],
  spacingSize: [4, 8, 12, 16, 24, 32, 40, 48, 56, 80, 120, 160],
  side: ["p", "pt", "pb", "pr", "pl", "m", "mt", "mb", "mr", "ml"],
  tableVariants: ["bounded", "unbounded", "bounded-fixed"],
  tableCellVariants: ["default", "tall"],
  tableScrollerVariants: ["last"]
};
/** Format Rgb Code so we can pick the code as designed */

exports.enums = enums;

const formatRgb = style => {
  const takeStr = style.backgroundColor.toString(); // Ensure this is a string

  return takeStr.substring(4, takeStr.length - 1);
};

exports.formatRgb = formatRgb;